// extracted by mini-css-extract-plugin
module.exports = {"projectRow":"styles_projectRow__12rj6"};